// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Logout = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M60.354 22.592V42.73a2 2 0 0 0 4 0V22.592c0-6.176-5.235-11.201-11.67-11.201H20.169c-6.434 0-11.669 5.025-11.669 11.201V82.609a2 2 0 0 0 4 0V22.592c0-3.971 3.44-7.201 7.669-7.201h32.515c4.23 0 7.67 3.23 7.67 7.201M87.376 54.96l.033-.105c.053-.18.091-.368.091-.567a2.02 2.02 0 0 0-.091-.568l-.033-.103a1.965 1.965 0 0 0-.266-.505c-.007-.01-.009-.02-.016-.03l-8.308-10.987a2 2 0 1 0-3.19 2.414l5.884 7.779H47.102a2 2 0 0 0 0 4H81.48l-5.884 7.78a1.999 1.999 0 1 0 3.19 2.412l8.308-10.986c.007-.009.009-.021.016-.029.112-.154.201-.324.266-.505M64.354 65.839v16.77a2 2 0 0 1-4 0v-16.77a2 2 0 0 1 4 0"
			fillRule="evenodd"
		/>
	</svg>
);
export default Logout;
